import { Star } from "lucide-react";

const testimonials = [
  { quote: "SecureFlex eliminated proxy check-ins overnight. Our clients saw the live map and immediately renewed their contracts. Game changer.", name: "James Mitchell", company: "Mitchell Security Services, London" },
  { quote: "The face verification combined with GPS geofencing means we can prove every patrol actually happened. No more he-said-she-said with site operators.", name: "Sarah Chen", company: "Guardian Watch, Singapore" },
  { quote: "We manage 12 sites across multiple cities. The multi-site dashboard gives me full visibility from one screen. Worth every penny.", name: "Carlos Rodriguez", company: "SecurePoint Group, Miami" },
];

const TestimonialsSection = () => (
  <section className="py-24">
    <div className="mx-auto max-w-7xl px-6">
      <p className="text-sm font-semibold tracking-widest text-primary">Testimonials</p>
      <h2 className="mt-2 text-3xl font-bold md:text-5xl">TRUSTED BY SECURITY LEADERS WORLDWIDE</h2>
      <div className="mt-12 grid gap-6 md:grid-cols-3">
        {testimonials.map((t, i) => (
          <div key={t.name} className="rounded-xl border border-border bg-card p-8 animate-fade-in" style={{ animationDelay: `${i * 0.15}s`, animationFillMode: "backwards" }}>
            <div className="mb-4 flex gap-1">
              {Array(5).fill(null).map((_, j) => (<Star key={j} className="h-5 w-5 fill-primary text-primary" />))}
            </div>
            <p className="mb-6 text-muted-foreground">"{t.quote}"</p>
            <p className="font-bold">{t.name}</p>
            <p className="text-sm text-muted-foreground">{t.company}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default TestimonialsSection;
